import { render, staticRenderFns } from "./sky-card.vue?vue&type=template&id=3b62dea7&scoped=true"
import script from "./sky-card.vue?vue&type=script&lang=js"
export * from "./sky-card.vue?vue&type=script&lang=js"
import style0 from "./sky-card.vue?vue&type=style&index=0&id=3b62dea7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b62dea7",
  null
  
)

export default component.exports